<template>
    <div class="MReportSearch" v-if="init">
        <SearchList :param="param" @getList="getList" :page="page"></SearchList>
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!reportlist.length"></NoData>
            <div class="searchList"  v-else>
                <div class="box" v-for="(obj) in reportlist" :key="obj.innerid" @click="gotoReport(obj)">
                    <div class="left"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                    <div class="right">
                        <div class="title">{{obj.subject}}</div>
                        <div class="sort">
                            <img :src="require('@/common/images/report/mobile/sort_icon.png')" alt="">
                            <span>{{obj.industryname}}</span>
                            <span>{{obj.industryname2}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
    import SearchList from 'views/reportMobile/search/components/searchList'
    import {getSearchResult} from 'api/reportApi'
    import Pull from 'views/mobile/components/pull/pull'
    import {mapGetters, mapActions} from 'vuex'
    import NoData from 'views/mobile/components/noData/noData'
    export default {
        name: "MReportSearch",
        data(){
            return{
                init: false,
                reportlist: [],
                param: {
                    key: this.$route.query.key ? decodeURI(this.$route.query.key) : '', //关键词
                    // key: this.$route.params.key? this.$route.params.key : '', //关键词
                    kmctype:2,
                    reportyeartype:this.$route.query.reportyeartype ? this.$route.query.reportyeartype : '', //报告排序 1正排 2倒排
                    catecode:this.$route.query.code ? this.$route.query.code : (this.$route.query.catecode ? this.$route.query.catecode : ''), //行业分类
                    feetype:this.$route.query.feetype ? this.$route.query.feetype : '', //报告类型
                    reportyear:this.$route.query.reportyear ? this.$route.query.reportyear : '', //报告年份
                    hostid: this.$route.query.hostid ? this.$route.query.hostid : '', // 发布方ID
                },
                page: {
                    page: 1,
                    pageSize: 10,
                    pageCount: 0,
                    rowCount: 0,
                },
                pull: {
                    isLoading: false,
                    loading: false,
                    error: false,
                    finished: false
                }
            }
        },
        created() {
            console.log(this.$route.query.key)
            if(!this.domainInfo.isMobile){
                this.$router.push({
                    name: 'ReportSearch',
                    query: {'catecode': this.$route.query.catecode,'data': this.$route.query.key ? encodeURI(this.param.key) : '',
                        'feetype': this.$route.query.feetype,'reportyear': this.$route.query.reportyear,'isMobile':1}
                })
            }
        },
        mounted() {
            this.setNoDataTip('当前暂无搜索结果！')
            console.log(this.param)
            if (!this.refresh) this.getList()
        },
        activated() {
            if (this.refresh) {
                this.param.key=this.$route.query.key ? decodeURI(this.$route.query.key) : '', //关键词
                this.param.kmctype=2,
                this.param.reportyeartype=this.$route.query.reportyeartype ? this.$route.query.reportyeartype : '', //报告排序 1正排 2倒排
                this.param.catecode=this.$route.query.code ? this.$route.query.code : (this.$route.query.catecode ? this.$route.query.catecode : ''), //行业分类
                this.param.feetype=this.$route.query.feetype ? this.$route.query.feetype : '', //报告类型
                this.param.reportyear=this.$route.query.reportyear ? this.$route.query.reportyear : '', //报告年份
                this.page.page=1
                this.getList()
                this.setRefresh(false)
            }
        },
        methods: {
            getList() {
                let params = JSON.parse(JSON.stringify(this.param))
                if (params.feetype === '3') {
                    params.feetype = ''
                    params.zjmemtype = 1
                }
                this.setLoading(true);
                getSearchResult({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.init = true;
                        if (this.page.page === 1) {
                            this.pull.isLoading = false;
                            this.reportlist = data.data.reportlist
                        } else {
                            this.reportlist = this.reportlist.concat(data.data.reportlist)
                        }
                        this.setLoading(false);
                        this.pull.loading = false;
                        this.page.pageCount = data.data.pageinfo.pageCount;
                        this.page.rowCount = data.data.pageinfo.rowCount;
                        if (this.page.page >= this.page.pageCount) {
                            this.pull.finished = true
                        }else{
                            this.pull.finished = false
                        }
                    },
                    error: data => {
                        this.setLoading(false);
                        this.pull.error = true;
                        this.pull.loading = false;
                        this.$toast.fail(data.msg)
                    }
                })
            },
            // 前往报告详情
            gotoReport(obj) {
                this.setRefresh(true);
                this.$router.push({name: 'MReportDetails', query: {reportid: obj.innerid}})
            },
            ...mapActions(['setLoading', 'setRefresh','setNoDataTip'])
        },
        computed: {
            ...mapGetters(['refresh','domainInfo'])
        },
        watch: {
            $route: {
                handler () { // val 更新的, oldVal 过去的
                    if (this.$route.query.code) {
                        this.param.catecode = this.$route.query.code
                    }
                    if (this.$route.query.key && decodeURI(this.$route.query.key)) {
                        this.param.key = decodeURI(this.$route.query.key)
                    }
                },
            }
        },
        components: {
            SearchList, Pull, NoData
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .MReportSearch {
        .searchList{
            padding: 0 0.32rem 0.16rem 0.32rem;
            background: $c-white;
            margin-top: 1.88rem;
            .box:first-child{
                padding-top: 0;
            }
            .box{
                display: flex;
                justify-content: flex-start;
                font-size:0.28rem;
                font-weight: 600;
                background: $c-white;
                padding: 0.16rem 0;
                .left{
                    min-width:2.6rem;
                    max-width: 2.6rem;
                    width: 2.6rem;
                    height: 1.46rem;
                    margin-right:0.2rem;
                    .img{
                        width: 100%;
                        height: 100%;
                        border-radius: 0.04rem;
                    }
                }
                .right{
                    width: 4.84rem;
                    .title{
                        height: 0.8rem;
                        line-height: 0.4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .sort{
                        margin-top: 0.16rem;
                        display: flex;
                        align-items: center;
                        color: #999;
                        font-size: 0.24rem;
                        img{
                            width: 0.24rem;
                            height: 0.24rem;
                            margin-right: 0.12rem;
                        }
                        span{
                            margin-right: 0.1rem;
                        }
                    }
                }
            }
        }
        .noData{
            height: calc(100vh - 1.88rem);
            background: $c-white;
        }
    }
</style>